// import React from 'react';
// import ReactDOM from 'react-dom';
// import App from './App';
// import * as serviceWorker from './serviceWorker';

// ReactDOM.render(<App />, document.getElementById('root'));

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

import React from 'react';
import { createRoot } from "react-dom/client";
import { ConfigProvider } from 'antd';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
const queryClient = new QueryClient();
root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#26a69a',
          colorPrimaryHover: '#67afc6',
          colorPrimaryActive: '#468090'
        },
      }}
    >
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
    </ConfigProvider>
  </React.StrictMode>
);
